// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_recorder.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_recorder.proto.
 */
export const file_plugnmeet_recorder: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message plugnmeet.PlugNmeetToRecorder
 */
export type PlugNmeetToRecorder = Message<"plugnmeet.PlugNmeetToRecorder"> & {
  /**
   * @generated from field: string from = 1;
   */
  from: string;

  /**
   * @generated from field: plugnmeet.RecordingTasks task = 2;
   */
  task: RecordingTasks;

  /**
   * @generated from field: int64 room_table_id = 3 [jstype = JS_STRING];
   */
  roomTableId: string;

  /**
   * @generated from field: string room_id = 4;
   */
  roomId: string;

  /**
   * @generated from field: string room_sid = 5;
   */
  roomSid: string;

  /**
   * @generated from field: string recording_id = 6;
   */
  recordingId: string;

  /**
   * @generated from field: string recorder_id = 7;
   */
  recorderId: string;

  /**
   * @generated from field: string access_token = 8;
   */
  accessToken: string;

  /**
   * @generated from field: optional string rtmp_url = 9;
   */
  rtmpUrl?: string | undefined;
};

/**
 * Describes the message plugnmeet.PlugNmeetToRecorder.
 * Use `create(PlugNmeetToRecorderSchema)` to create a new message.
 */
export const PlugNmeetToRecorderSchema: GenMessage<PlugNmeetToRecorder> = /*@__PURE__*/
  messageDesc(file_plugnmeet_recorder, 0);

/**
 * @generated from message plugnmeet.RecorderToPlugNmeet
 */
export type RecorderToPlugNmeet = Message<"plugnmeet.RecorderToPlugNmeet"> & {
  /**
   * @generated from field: string from = 1;
   */
  from: string;

  /**
   * @generated from field: plugnmeet.RecordingTasks task = 2;
   */
  task: RecordingTasks;

  /**
   * @generated from field: bool status = 3;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 4;
   */
  msg: string;

  /**
   * @generated from field: string recording_id = 5;
   */
  recordingId: string;

  /**
   * @generated from field: int64 room_table_id = 11 [jstype = JS_STRING];
   */
  roomTableId: string;

  /**
   * @generated from field: string room_id = 6;
   */
  roomId: string;

  /**
   * @generated from field: string room_sid = 7;
   */
  roomSid: string;

  /**
   * @generated from field: string recorder_id = 8;
   */
  recorderId: string;

  /**
   * @generated from field: string file_path = 9;
   */
  filePath: string;

  /**
   * @generated from field: float file_size = 10;
   */
  fileSize: number;

  /**
   * next key 13
   *
   * @generated from field: optional plugnmeet.CloudRecordingVariants recording_variant = 12;
   */
  recordingVariant?: CloudRecordingVariants | undefined;
};

/**
 * Describes the message plugnmeet.RecorderToPlugNmeet.
 * Use `create(RecorderToPlugNmeetSchema)` to create a new message.
 */
export const RecorderToPlugNmeetSchema: GenMessage<RecorderToPlugNmeet> = /*@__PURE__*/
  messageDesc(file_plugnmeet_recorder, 1);

/**
 * @generated from message plugnmeet.TranscodingTaskPostRecording
 */
export type TranscodingTaskPostRecording = Message<"plugnmeet.TranscodingTaskPostRecording"> & {
  /**
   * directory where raw file is stored
   *
   * @generated from field: string file_path = 1;
   */
  filePath: string;

  /**
   * raw file name e.g. rec-xxx_raw.mp4
   *
   * @generated from field: string file_name = 2;
   */
  fileName: string;

  /**
   * The variant of the recording
   *
   * @generated from field: plugnmeet.CloudRecordingVariants recording_variant = 3;
   */
  recordingVariant: CloudRecordingVariants;
};

/**
 * Describes the message plugnmeet.TranscodingTaskPostRecording.
 * Use `create(TranscodingTaskPostRecordingSchema)` to create a new message.
 */
export const TranscodingTaskPostRecordingSchema: GenMessage<TranscodingTaskPostRecording> = /*@__PURE__*/
  messageDesc(file_plugnmeet_recorder, 2);

/**
 * @generated from message plugnmeet.TranscodingTaskMergeRecordings
 */
export type TranscodingTaskMergeRecordings = Message<"plugnmeet.TranscodingTaskMergeRecordings"> & {
  /**
   * @generated from field: repeated string file_paths = 1;
   */
  filePaths: string[];
};

/**
 * Describes the message plugnmeet.TranscodingTaskMergeRecordings.
 * Use `create(TranscodingTaskMergeRecordingsSchema)` to create a new message.
 */
export const TranscodingTaskMergeRecordingsSchema: GenMessage<TranscodingTaskMergeRecordings> = /*@__PURE__*/
  messageDesc(file_plugnmeet_recorder, 3);

/**
 * TranscodingTask will be the job for the transcoding worker.
 *
 * @generated from message plugnmeet.TranscodingTask
 */
export type TranscodingTask = Message<"plugnmeet.TranscodingTask"> & {
  /**
   * @generated from field: string recording_id = 1;
   */
  recordingId: string;

  /**
   * @generated from field: string room_id = 2;
   */
  roomId: string;

  /**
   * @generated from field: string room_sid = 3;
   */
  roomSid: string;

  /**
   * @generated from field: int64 room_table_id = 4 [jstype = JS_STRING];
   */
  roomTableId: string;

  /**
   * ID of the original recorder that captured the file
   *
   * @generated from field: string recorder_id = 5;
   */
  recorderId: string;

  /**
   * @generated from oneof plugnmeet.TranscodingTask.task_details
   */
  taskDetails: {
    /**
     * @generated from field: plugnmeet.TranscodingTaskPostRecording post_recording = 6;
     */
    value: TranscodingTaskPostRecording;
    case: "postRecording";
  } | {
    /**
     * @generated from field: plugnmeet.TranscodingTaskMergeRecordings merge_recordings = 7;
     */
    value: TranscodingTaskMergeRecordings;
    case: "mergeRecordings";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message plugnmeet.TranscodingTask.
 * Use `create(TranscodingTaskSchema)` to create a new message.
 */
export const TranscodingTaskSchema: GenMessage<TranscodingTask> = /*@__PURE__*/
  messageDesc(file_plugnmeet_recorder, 4);

/**
 * @generated from enum plugnmeet.RecordingTasks
 */
export enum RecordingTasks {
  /**
   * @generated from enum value: START_RECORDING = 0;
   */
  START_RECORDING = 0,

  /**
   * @generated from enum value: STOP_RECORDING = 1;
   */
  STOP_RECORDING = 1,

  /**
   * @generated from enum value: START_RTMP = 2;
   */
  START_RTMP = 2,

  /**
   * @generated from enum value: STOP_RTMP = 3;
   */
  STOP_RTMP = 3,

  /**
   * @generated from enum value: END_RECORDING = 4;
   */
  END_RECORDING = 4,

  /**
   * @generated from enum value: END_RTMP = 5;
   */
  END_RTMP = 5,

  /**
   * @generated from enum value: RECORDING_PROCEEDED = 6;
   */
  RECORDING_PROCEEDED = 6,

  /**
   * @generated from enum value: STOP = 7;
   */
  STOP = 7,

  /**
   * @generated from enum value: RECORDING_TRANSCODING_FINISHED = 8;
   */
  RECORDING_TRANSCODING_FINISHED = 8,
}

/**
 * Describes the enum plugnmeet.RecordingTasks.
 */
export const RecordingTasksSchema: GenEnum<RecordingTasks> = /*@__PURE__*/
  enumDesc(file_plugnmeet_recorder, 0);

/**
 * @generated from enum plugnmeet.RecorderInfoKeys
 */
export enum RecorderInfoKeys {
  /**
   * @generated from enum value: RECORDER_INFO_MAX_LIMIT = 0;
   */
  RECORDER_INFO_MAX_LIMIT = 0,

  /**
   * @generated from enum value: RECORDER_INFO_LAST_PING = 1;
   */
  RECORDER_INFO_LAST_PING = 1,

  /**
   * Total CPU cores
   *
   * @generated from enum value: RECORDER_INFO_TOTAL_CORES = 2;
   */
  RECORDER_INFO_TOTAL_CORES = 2,

  /**
   * @generated from enum value: RECORDER_INFO_CURRENT_PROGRESS = 3;
   */
  RECORDER_INFO_CURRENT_PROGRESS = 3,

  /**
   * @generated from enum value: RECORDER_INFO_CPU_SCORE = 4;
   */
  RECORDER_INFO_CPU_SCORE = 4,
}

/**
 * Describes the enum plugnmeet.RecorderInfoKeys.
 */
export const RecorderInfoKeysSchema: GenEnum<RecorderInfoKeys> = /*@__PURE__*/
  enumDesc(file_plugnmeet_recorder, 1);

/**
 * @generated from enum plugnmeet.CloudRecordingVariants
 */
export enum CloudRecordingVariants {
  /**
   * @generated from enum value: FULL_SCREEN_CLOUD_RECORDING = 0;
   */
  FULL_SCREEN_CLOUD_RECORDING = 0,

  /**
   * @generated from enum value: MEDIA_ONLY_CLOUD_RECORDING = 1;
   */
  MEDIA_ONLY_CLOUD_RECORDING = 1,
}

/**
 * Describes the enum plugnmeet.CloudRecordingVariants.
 */
export const CloudRecordingVariantsSchema: GenEnum<CloudRecordingVariants> = /*@__PURE__*/
  enumDesc(file_plugnmeet_recorder, 2);

